import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Receipt } from 'lucide-react';
import { shopAPI } from '../lib/api';
import { t } from '../lib/i18n';
import MyLearningShell from '../components/MyLearningShell';
import { EmptyState, panelCls } from '../components/ui';

export default function MyPurchases() {
  const [payments, setPayments] = useState(null);

  useEffect(() => {
    shopAPI.purchases().then(({ data }) => setPayments(data.payments)).catch(() => setPayments([]));
  }, []);

  if (!payments) return <MyLearningShell><p className="text-sm text-lms-muted">{t('Loading…')}</p></MyLearningShell>;

  return (
    <MyLearningShell>
      <div className="mx-auto max-w-3xl">
      {payments.length === 0 ? (
        <EmptyState>{t('No purchases yet.')}</EmptyState>
      ) : (
        <div className={`${panelCls} overflow-x-auto`}>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-lms-border text-left text-xs text-lms-faint">
                <th className="px-4 py-2.5 font-medium">{t('Course')}</th>
                <th className="px-3 py-2.5 font-medium">{t('Amount')}</th>
                <th className="px-3 py-2.5 font-medium">{t('Date')}</th>
                <th className="px-3 py-2.5" />
              </tr>
            </thead>
            <tbody>
              {payments.map((p) => (
                <tr key={p.id} className="border-b border-lms-border last:border-b-0">
                  <td className="px-4 py-2.5">
                    {p.course ? (
                      <Link to={`/course/${p.course.slug}`} className="hover:text-lms-accent">{p.course.title}</Link>
                    ) : '—'}
                  </td>
                  <td className="px-3 py-2.5 lms-num">${Number(p.amount).toFixed(2)} <span className="text-xs uppercase text-lms-faint">{p.currency}</span></td>
                  <td className="px-3 py-2.5 text-xs text-lms-faint lms-num">{(p.created_at || '').slice(0, 10)}</td>
                  <td className="px-3 py-2.5 text-right">
                    <Link to={`/my/invoices/${p.id}`} className="inline-flex items-center gap-1 text-lms-accent hover:brightness-110">
                      <Receipt size={13} />
                      {t('Invoice')}
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      </div>
    </MyLearningShell>
  );
}
